import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Save, Plus, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";

const FAQEditor = ({ content, onSave }) => {
  const [formData, setFormData] = useState({
    section_label: "",
    title: "",
    subtitle: "",
    faqs: []
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (content) {
      setFormData(content);
    }
  }, [content]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFAQChange = (index, field, value) => {
    const updated = [...formData.faqs];
    updated[index] = { ...updated[index], [field]: value };
    setFormData({ ...formData, faqs: updated });
  };

  const addFAQ = () => {
    const newFAQ = {
      id: `faq-${Date.now()}`,
      question: "Nueva pregunta",
      answer: "Respuesta a la pregunta..."
    };
    setFormData({ ...formData, faqs: [...formData.faqs, newFAQ] });
  };

  const removeFAQ = (index) => {
    const updated = formData.faqs.filter((_, i) => i !== index);
    setFormData({ ...formData, faqs: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const success = await onSave(formData);
    setSaving(false);
    if (success) {
      toast.success("FAQs actualizadas correctamente");
    } else {
      toast.error("Error al guardar los cambios");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid="faq-editor"
    >
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Editar FAQs</h1>
          <p className="text-[#94a3b8]">Administra las preguntas frecuentes</p>
        </div>
        <button onClick={addFAQ} className="btn-secondary flex items-center gap-2">
          <Plus className="w-5 h-5" />
          <span>Agregar FAQ</span>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="glass-card p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Textos de la Sección</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Etiqueta</label>
              <input type="text" name="section_label" value={formData.section_label} onChange={handleChange} className="contact-input w-full" />
            </div>
            <div>
              <label className="block text-[#94a3b8] text-sm mb-2">Título</label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} className="contact-input w-full" />
            </div>
          </div>
          <div className="mt-4">
            <label className="block text-[#94a3b8] text-sm mb-2">Subtítulo</label>
            <textarea name="subtitle" value={formData.subtitle} onChange={handleChange} rows={2} className="contact-input w-full resize-none" />
          </div>
        </div>

        <div className="space-y-4">
          {formData.faqs.map((faq, index) => (
            <div key={faq.id} className="glass-card p-6">
              <div className="flex items-start gap-4">
                <span className="text-[#3b82f6] font-bold text-lg">{index + 1}</span>
                <div className="flex-1 space-y-4">
                  <div>
                    <label className="block text-[#94a3b8] text-sm mb-2">Pregunta</label>
                    <input
                      type="text"
                      value={faq.question}
                      onChange={(e) => handleFAQChange(index, "question", e.target.value)}
                      className="contact-input w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-[#94a3b8] text-sm mb-2">Respuesta</label>
                    <textarea
                      value={faq.answer}
                      onChange={(e) => handleFAQChange(index, "answer", e.target.value)}
                      rows={3}
                      className="contact-input w-full resize-none"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => removeFAQ(index)}
                  className="p-2 text-red-400 hover:bg-red-500/10 rounded"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end">
          <button type="submit" disabled={saving} className="btn-primary flex items-center gap-2">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />}
            <span>{saving ? "Guardando..." : "Guardar Cambios"}</span>
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default FAQEditor;
